<template>
  <IndexPageSection
    :need-link="false"
    :section-name="'categories'"
    :title="'カテゴリから探す'"
  >
    <div class="categories__items">
      <a
        class="tl-list tl-list__text chevron--forward--black"
        :href="allCategoryLinkUrl"
        :data-gtm-page="dataGtmPage"
        :data-gtm-click="dataGtmPage ? 'category_all' : null"
        @click="onClickCategory('')"
      >
        すべて
      </a>
      <a
        v-for="category in categories"
        :key="category.id"
        class="tl-list tl-list__text chevron--forward--black"
        :href="linkUrl(category.id)"
        :data-gtm-page="dataGtmPage"
        :data-gtm-click="dataGtmPage ? 'category' : null"
        :data-gtm-category-id="dataGtmPage ? category.id : null"
        @click="onClickCategory(category.id)"
      >
        {{ category.name }}
      </a>
    </div>
  </IndexPageSection>
</template>
<script>
import qs from 'qs'
import IndexPageSection from './IndexPageSection.vue'
import axios from 'axios'
export default {
  components: { IndexPageSection },
  props: {
    itemLinkBasePath: {
      type: String,
      required: false,
      default: ''
    },
    itemLinkParams: {
      type: Object,
      required: false,
      default: () => ({})
    },
    dataGtmPage: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      categories: [],
      isCategoriesLoading: false
    }
  },
  computed: {
    allCategoryLinkUrl() {
      const paramsString = qs.stringify(this.itemLinkParams, {
        arrayFormat: 'brackets'
      })
      return `${this.itemLinkBasePath}/items?${paramsString}`
    }
  },
  mounted() {
    this.getCategories()
  },
  methods: {
    linkUrl(categoryId) {
      const paramsString = qs.stringify(
        {
          category_id: categoryId,
          ...this.itemLinkParams
        },
        { arrayFormat: 'brackets' }
      )

      return `${this.itemLinkBasePath}/items?${paramsString}`
    },
    async getCategories() {
      this.isCategoriesLoading = true
      try {
        const res = await axios.get('/api/v1/pickup/item_categories')
        this.categories = res.data.data
          .map(category => category.attributes)
          .map(({ id, name }) => ({ id, name }))
        this.isCategoriesLoading = false
      } catch (error) {
        this.isCategoriesLoading = false
        const message =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', message)
      }
    },
    onClickCategory(categoryId) {
      this.$emit('click-category', categoryId)
    }
  }
}
</script>
